import React, { useEffect, useState } from "react";
import { Swords } from "lucide-react";
import { api } from "../lib/api";

const money = (v) => (v === null || v === undefined ? "--" : `${v < 0 ? "-" : "+"}$${Math.abs(v).toLocaleString(undefined, { maximumFractionDigits: 0 })}`);
const tone = (v) => (v === null || v === undefined ? "text-cyan-100/50" : v >= 0 ? "text-emerald-300" : "text-rose-300");

export const HerculesScorecard = () => {
  const [d, setD] = useState(null);
  useEffect(() => {
    const load = () => api.get("/hercules/floor").then((r) => setD(r.data)).catch(() => {});
    load();
    const t = setInterval(load, 120000);
    return () => clearInterval(t);
  }, []);
  const herc = d && d.today.trades.length ? d.today.pnl : null;
  const av = d ? d.av_trading_day_pnl : null;
  return (
    <div className="flex items-center gap-3 px-4 py-1.5 border-b border-[#F5C45122] bg-[#F5C4510a] nx-mono text-[11px] shrink-0" data-testid="nexus-chat-scorecard">
      <Swords className="w-3.5 h-3.5 text-[#F5C451]" />
      <span className="text-[#F5C451] tracking-widest">ON NOTICE</span>
      <span className="text-cyan-100/50">Hercules 2.0</span><b className={tone(herc)} data-testid="scorecard-hercules-pnl">{money(herc)}</b>
      <span className="text-cyan-100/30">vs</span>
      <span className="text-cyan-100/50">AV Trading v3</span><b className={tone(av)} data-testid="scorecard-av-pnl">{money(av)}</b>
      <span className="text-cyan-100/30 ml-auto hidden sm:inline">today</span>
    </div>
  );
};
